import { render, staticRenderFns } from "./electiveDialog.vue?vue&type=template&id=27355fb0&"
import script from "./electiveDialog.vue?vue&type=script&lang=js&"
export * from "./electiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports